import { timeline } from "@/mocks/evidence";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="max-w-2xl">
          <p className="eyebrow text-xs font-semibold text-primary-700">02 / 证据时间线</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按日期把证据对齐，点开即可复核
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px]">
            不用再跨平台自己拼凑比对。每一档档案都沿时间轴排布，实锤截图、聊天记录与录音视频按发生顺序归位。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {timeline.map((tl) => (
            <article
              key={tl.date}
              className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
                <div className="flex items-center gap-3">
                  <span className="font-heading text-2xl font-bold text-primary-600">{tl.date}</span>
                  <span className="text-xs text-foreground-500">{tl.week}</span>
                </div>
                <span className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">
                  {tl.cat}
                </span>
              </div>

              <div className="flex flex-1 flex-col px-5 pb-5 pt-5">
                <h3 className="font-heading text-lg font-semibold leading-snug text-foreground-950">
                  {tl.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{tl.summary}</p>

                <div className="relative mt-5 flex-1 border-l border-background-300 pl-4">
                  {tl.items.map((it) => (
                    <div key={it} className="relative mb-3 last:mb-0">
                      <span className="absolute -left-[21px] top-1.5 h-2 w-2 rounded-full bg-primary-500 ring-2 ring-background-50" />
                      <p className="text-xs text-foreground-700">{it}</p>
                    </div>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex items-center justify-center">
          <a
            href="#pack"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-primary-700 hover:text-primary-800"
          >
            打开完整时间轴 <i className="ri-arrow-right-down-line" />
          </a>
        </div>
      </div>
    </section>
  );
}